import React from "react";
import { Widget } from "@typeform/embed-react";

const Typeform = ({ form }) => {
  const id = form?.split("/to/").pop();

  return <Widget id={id} height={640} inlineOnMobile />;
};

export default Typeform;
